import { SteeringDataAPI } from "@ai360/core";

// Maps the numeric embedding status to its display label.
export const getEmbeddingStatusLabel = (status: number): string => {
    switch (status) {
        case SteeringDataAPI.EMBEDDING_STATUS.PENDING:
            return "Pending";
        case SteeringDataAPI.EMBEDDING_STATUS.PROCESSING:
            return "Processing";
        case SteeringDataAPI.EMBEDDING_STATUS.COMPLETE:
            return "Ready";
        case SteeringDataAPI.EMBEDDING_STATUS.FAILED:
            return "Failed";
        default:
            return "Pending";
    }
};

// Color class per status label (green Ready, orange Processing, red Failed,
// neutral Pending). Shared by the grid and the child sublist.
export const STATUS_CLASS_BY_LABEL: Record<string, string> = {
    Ready: "steering-data-status--ready",
    Processing: "steering-data-status--processing",
    Failed: "steering-data-status--failed",
    Pending: "steering-data-status--pending",
};

export const getStatusClassName = (label: string): string =>
    `steering-data-status ${STATUS_CLASS_BY_LABEL[label] || "steering-data-status--pending"}`;
